import {
  GENERAL_STORE,
  GeneralStore,
  routingStore,
  ROUTING_STORE,
  USER_STORE,
  UserStore,
  PERSON_STORE,
  PersonStore,
  PROJECT_STORE,
  ProjectStore,
  PROJECT_PAGE_STORE,
  ProjectPageStore,
  BRAND_STORE,
  BrandStore,
  PRODUCT_STORE,
  ProductStore,
  AGREEMENT_STORE,
  AgreementStore,
  EDITOR_STORE,
  EditorStore,
  EDITOR_TIMELINE_STORE,
  EditorTimelineStore,
  EDITOR_MONITOR_STORE,
  EditorMonitorStore,
  EDITOR_CONTEXT_MENU_STORE,
  EditorContextMenuStore,
  EDITOR_ITEMS_HANDLER_STORE,
  EditorItemsHandlerStore,
  EDITOR_HOTKEYS_STORE,
  EditorHotkeysStore,
  EDITOR_SHOTS_STORE,
  EditorShotsStore,
  EDITOR_GROUPS_STORE,
  EditorGroupsStore,
  EDITOR_LOCATIONS_STORE,
  EditorLocationsStore,
  EDITOR_INTERACTIVE_AREAS_STORE,
  EditorInteractiveAreasStore,
  EDITOR_SPRITE_FRAMES_STORE,
  EditorSpriteFramesStore,
  VIEWERS_STORE,
  ViewersStore,
  EDITOR_ACTION_HISTORY_STORE,
  EditorActionHistoryStore,
  PRODUCT_SKU_STORE,
  ProductSkuStore,
  BRAND_PRODUCTS_STORE,
  BrandProductsStore,
  PERSONS_TABLE_STORE,
  PersonsTableStore,
  PersonProjectsTableStore,
  PERSON_PROJECTS_TABLE_STORE,
  ProjectsTableStore,
  PROJECTS_TABLE_STORE,
  AgreementsTableStore,
  AGREEMENTS_TABLE_STORE,
  AgreementPageStore,
  AGREEMENT_PAGE_STORE,
  USERS_TABLE_STORE,
  UsersTableStore,
  ACTION_HISTORY_TABLE_STORE,
  ActionHistoryTableStore,
  INVITE_USER_STORE,
  InviteUserStore,
  USER_PROFILE_STORE,
  UserProfileStore,
  STATISTICS_PAGE_STORE,
  StatisticsPageStore,
  PRODUCTS_MAIN_STORE,
  ProductsMainStore,
  PROJECT_MAIN_STORE,
  ProjectMainStore,
  STATISTICS_OVERVIEW_STORE,
  StatisticsOverviewStore,
  STATISTICS_OVERVIEW_TABLE_STORE,
  StatisticsOverviewTableStore,
  STATISTICS_OVERVIEW_BAR_CHART_STORE,
  StatisticsOverviewBarChartStore,
  BRANDS_MAIN_STORE,
  BrandsMainStore,
  STATISTICS_VIEWER_STORE,
  StatisticsViewerStore,
  StatisticsViewersTableStore,
  STATISTICS_VIEWERS_TABLE_STORE,
  StatisticsViewerPeriodChartStore,
  STATISTICS_OVERVIEW_PERIOD_CHART_STORE,
  DashboardPageStore,
  DASHBOARD_PAGE_STORE,
  NOTIFICATIONS_STORE,
  NotificationsStore,
  VIEWERS_TABLE_STORE,
  ViewersTableStore,
  IMAGE_EDITOR_STORE,
  ImageEditorStore,
  SPORT_POLL_STORE,
  SportPollStore
} from 'store'
import { enableLogging } from 'mobx-logger'
import { create } from 'mobx-persist'

export class RootStore {
  [ROUTING_STORE] = routingStore;
  [GENERAL_STORE] = new GeneralStore(this);
  [USER_STORE] = new UserStore(this);
  [PERSON_STORE] = new PersonStore(this);
  [PROJECT_STORE] = new ProjectStore(this);
  [PROJECT_PAGE_STORE] = new ProjectPageStore(this);
  [BRAND_STORE] = new BrandStore(this);
  [PRODUCT_STORE] = new ProductStore(this);
  [AGREEMENT_STORE] = new AgreementStore(this);
  [AGREEMENTS_TABLE_STORE] = new AgreementsTableStore(this);
  [EDITOR_STORE] = new EditorStore(this);
  [EDITOR_TIMELINE_STORE] = new EditorTimelineStore(this);
  [EDITOR_MONITOR_STORE] = new EditorMonitorStore(this);
  [EDITOR_CONTEXT_MENU_STORE] = new EditorContextMenuStore(this);
  [EDITOR_ITEMS_HANDLER_STORE] = new EditorItemsHandlerStore(this);
  [EDITOR_HOTKEYS_STORE] = new EditorHotkeysStore(this);
  [EDITOR_SHOTS_STORE] = new EditorShotsStore(this);
  [EDITOR_GROUPS_STORE] = new EditorGroupsStore(this);
  [EDITOR_LOCATIONS_STORE] = new EditorLocationsStore(this);
  [EDITOR_INTERACTIVE_AREAS_STORE] = new EditorInteractiveAreasStore(this);
  [EDITOR_SPRITE_FRAMES_STORE] = new EditorSpriteFramesStore(this);
  [VIEWERS_STORE] = new ViewersStore(this);
  [EDITOR_ACTION_HISTORY_STORE] = new EditorActionHistoryStore(this);
  [PRODUCT_SKU_STORE] = new ProductSkuStore(this);
  [BRAND_PRODUCTS_STORE] = new BrandProductsStore(this);
  [PERSONS_TABLE_STORE] = new PersonsTableStore(this);
  [PERSON_PROJECTS_TABLE_STORE] = new PersonProjectsTableStore(this);
  [PROJECTS_TABLE_STORE] = new ProjectsTableStore(this);
  [AGREEMENT_PAGE_STORE] = new AgreementPageStore(this);
  [USERS_TABLE_STORE] = new UsersTableStore(this);
  [ACTION_HISTORY_TABLE_STORE] = new ActionHistoryTableStore(this);
  [INVITE_USER_STORE] = new InviteUserStore(this);
  [USER_PROFILE_STORE] = new UserProfileStore(this);
  [STATISTICS_PAGE_STORE] = new StatisticsPageStore(this);
  [PRODUCTS_MAIN_STORE] = new ProductsMainStore(this);
  [PROJECT_MAIN_STORE] = new ProjectMainStore(this);
  [STATISTICS_OVERVIEW_STORE] = new StatisticsOverviewStore(this);
  [STATISTICS_OVERVIEW_TABLE_STORE] = new StatisticsOverviewTableStore(this);
  [STATISTICS_OVERVIEW_BAR_CHART_STORE] = new StatisticsOverviewBarChartStore(this);
  [BRANDS_MAIN_STORE] = new BrandsMainStore(this);
  [STATISTICS_VIEWER_STORE] = new StatisticsViewerStore(this);
  [STATISTICS_VIEWERS_TABLE_STORE] = new StatisticsViewersTableStore(this);
  [STATISTICS_OVERVIEW_PERIOD_CHART_STORE] = new StatisticsViewerPeriodChartStore(this);
  [DASHBOARD_PAGE_STORE] = new DashboardPageStore();
  [NOTIFICATIONS_STORE] = new NotificationsStore(this);
  [VIEWERS_TABLE_STORE] = new ViewersTableStore(this);
  [IMAGE_EDITOR_STORE] = new ImageEditorStore(this);
  [SPORT_POLL_STORE] = new SportPollStore(this);

  constructor () {
    // console.log('HERE')

    const hydrate = create()
    hydrate(DASHBOARD_PAGE_STORE, this[DASHBOARD_PAGE_STORE])
    // .then(result =>

    // console.log('result', result)
    // )
  }

  public clearStores = () => {
    this[DASHBOARD_PAGE_STORE].clearStore()
    // TODO: clear all stores
  }
}

enableLogging({
  predicate: () => false, // logger on/off condition
  action: true,
  reaction: false,
  transaction: false,
  compute: false
})
